import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'reporteIngreso'
})
export class ReporteIngresoPipe implements PipeTransform {

  transform(reactivos: any[], searchText: string): unknown {
    if (!reactivos) return [];
    if (!searchText) return reactivos;
  
    searchText = searchText.toLowerCase();
  
    return reactivos.filter( it => {
      return it.Empresa.toLowerCase().includes(searchText)
      || it.Status.toLowerCase().includes(searchText);
    });
  }
}
